import { TooltipInfo } from "@/components/Icons";
import { LabelText } from "@/modules/editor/components/styleComponents/Texts";
import { userAssetsStore, HeartCoinInfo } from "@/stores/userAssets";
import { WithClassName } from "@/types/base";
import { useTranslate } from "@/utils/lang";
import { User_Assets_Words } from "@/utils/lang/userAsset";
import { isAuthUser, isVip } from "@/utils/status";
import { chakra, Flex, Text } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";

type ShowLabelFieldType = Extract<keyof HeartCoinInfo, "total" | "payed">;
const labelText: Record<ShowLabelFieldType, User_Assets_Words> = {
  total: User_Assets_Words["total_coin"],
  payed: User_Assets_Words["paid_coin"],
};
const _CoinsStatusText: React.FC<
  WithClassName<{
    showItem?: ShowLabelFieldType;
  }>
> = ({ showItem, className }) => {
  const { translate } = useTranslate();
  const { heartCoinInfo, setHeartCoinPayModalOpen } = userAssetsStore;

  const _showItem = showItem ?? "total";

  const needShow = useMemo(() => {
    if (!isAuthUser()) return false;
    if (_showItem === "total" && isVip()) {
      return false;
    }
    return true;
  }, [isAuthUser(), isVip(), showItem]);

  if (!needShow) return null;
  return (
    <Flex w="100%" justifyContent="space-between" mb="8px" className={className}>
      <TooltipInfo
        title={
          <LabelText color="text.lightDisabled" fontSize="12px">
            {translate(User_Assets_Words.rest)}
            {translate(labelText[_showItem])} ⭐：{heartCoinInfo[_showItem]}
          </LabelText>
        }
        info={
          <Flex flexDir="column" fontSize="14px" lineHeight="22px" color="white">
            {isVip() ? (
              <>
                <Text whiteSpace="nowrap">
                  {translate(User_Assets_Words.paid_heart_coin)}：{heartCoinInfo.payed}
                </Text>
                <Text whiteSpace="nowrap">{translate(User_Assets_Words.paid_coin_vip_tip)}</Text>
              </>
            ) : (
              <>
                <Text whiteSpace="nowrap">
                  {translate(User_Assets_Words.free_coin)}：{heartCoinInfo.free}
                  {translate(User_Assets_Words.free_coin_use_tip)}
                </Text>
                <Text whiteSpace="nowrap">
                  {translate(User_Assets_Words.paid_coin)}：{heartCoinInfo.payed}
                </Text>
              </>
            )}
          </Flex>
        }
        tooltipProps={{
          arrowSize: 4,
          maxWidth: "fit-content",
        }}
        onIconClick={() => setHeartCoinPayModalOpen(true)}
      />
      <Text
        color="brand.primary"
        cursor="pointer"
        fontSize="12px"
        onClick={() => setHeartCoinPayModalOpen(true)}
      >
        {translate(User_Assets_Words.get_more_coin)}
      </Text>
    </Flex>
  );
};

export const CoinsStatusText = chakra(observer(_CoinsStatusText));
